/**
 * Constantes compartilhadas para o fluxo de salvamento
 */

// Timeouts e Retries
export const METADATA_MAX_RETRIES = 3;
export const METADATA_BASE_TIMEOUT = 5000;
export const METADATA_TIMEOUT_INCREMENT = 500;
export const METADATA_RETRY_DELAY = 500;

// Delays de Estabilização (ms)
export const DELAY_MODAL_STABILIZATION = 200;
export const DELAY_BEFORE_API = 200;
export const DELAY_AFTER_API = 200;
export const DELAY_SHORT = 100;
export const DELAY_CLOSING_MODAL = 150;
export const DELAY_ERROR_RECOVERY = 1000;

// Progresso (valores percentuais)
export const PROGRESS_INITIAL = 5;
export const PROGRESS_AFTER_COREL = 10;
export const PROGRESS_AFTER_METADATA = 50;
export const PROGRESS_BEFORE_API = 60;
export const PROGRESS_AFTER_API = 90;
export const PROGRESS_COMPLETE = 100;
export const PROGRESS_MAX_WITHOUT_RESPONSE = 80;
export const PROGRESS_INCREMENT = 5;
export const PROGRESS_INTERVAL_MS = 200;

// Horários Padrão
export const DEFAULT_TIME = '18:00';
export const TIME_AMANHA = '09:00';
export const TIME_NOTURNA = '22:00';
export const TIME_URGENTE = '12:00';

// Mensagens de Erro Padrão
export const ERROR_PREPARE_DATA = 'Erro ao preparar dados para envio';
export const ERROR_INSUFFICIENT_DATA = 'Dados insuficientes para salvar. Campos ausentes: ';
export const ERROR_COREL_TIMEOUT = 'Tempo esgotado aguardando resposta do Corel. Verifique o Corel/WebView e tente novamente.';
export const ERROR_NO_SAVE_DATA = 'Dados de salvamento não encontrados';
export const ERROR_NO_PATH_RETURNED = 'SAVE_ERROR:NO_PATH_RETURNED: C# não retornou caminho do arquivo salvo';
export const ERROR_INVALID_PATH = 'Caminho de arquivo inválido retornado pelo CorelDRAW';
export const ERROR_NO_METADATA = 'Falha ao coletar metadados de objetos';
export const ERROR_NO_OBJECTS_METADATA = 'Nenhum objeto foi coletado dos metadados';
export const ERROR_OPERATION_CANCELLED = 'Operação cancelada pelo usuário';
export const ERROR_DOCUMENT_CLOSED = 'Salvamento cancelado: documento foi fechado';
export const ERROR_DOCUMENT_CLOSED_DURING = 'Salvamento cancelado: documento foi fechado durante o processo';
export const ERROR_DOCUMENT_CLOSED_METADATA = 'Salvamento cancelado: documento foi fechado durante coleta de metadados';
export const ERROR_DOCUMENT_CLOSED_BEFORE_API = 'Salvamento cancelado: documento foi fechado antes de registrar na API';

// Mensagem WhatsApp Template
export const WHATSAPP_PHONE = '(555) 600-0657';
export const EXPEDITION_PHONE = '(62) 9531-1320';

/**
 * Gera template de mensagem WhatsApp para cliente
 */
export function generateWhatsAppTemplate(data: {
  clienteNome: string;
  pedidoId: string;
  produtoNome: string;
  previsao: string;
}): string {
  return `📌 *STATUS DO PEDIDO* 📌

*${data.clienteNome}*, seu pedido *#${data.pedidoId}*  
(${data.produtoNome}) está em produção! ✅

━━━━━━━━━━━━━━  
🛠️ *Status*: Processando seu pedido  
⏰ *Previsão*: ${data.previsao}  
━━━━━━━━━━━━━━  

📲 *Acompanhamento*:  
Após confirmação do pagamento, você receberá:  
• Link exclusivo via WhatsApp  
• Número: *${WHATSAPP_PHONE}*  

📦 *Contato Expedição*:  
${EXPEDITION_PHONE} *(retirada/entrega)*  

Agradecemos pela confiança! 🙌`;
}

// Tipos de Idempotency Key
export const IDEM_KEY_TYPE_SAVE = 'SAVE';
export const IDEM_KEY_TYPE_TEMP = 'TEMP';
export const IDEM_KEY_MAX_LENGTH = 128;

// Padrões de caminho (detecção de fluxo)
export const PATH_PATTERN_TEMP = 'FileSecuritySystemProd\\PRODUCAO';

// Estados de salvamento válidos
export const SAVE_STATE_SAVING = 'saving' as const;
export const SAVE_STATE_SUCCESS = 'success' as const;
export const SAVE_STATE_ERROR = 'error' as const;
export const SAVE_STATE_UPLOADING = 'uploading' as const;
export const SAVE_STATE_CANCELLED = 'cancelled' as const;
export const SAVE_STATE_EXPORTING = 'exporting' as const;

